export default class Card {
    public number: any = ''
    public expMonth: any = ''
    public expYear: any = ''
    public cvc: any = ''
}